const contactList = [
    {
        image: '/assets/img/pages/contacts/whatsapp.svg',
        label: '021 96544 3935',
        action: 'WhatsApp',
        link: 'https://wa.me/5521965443935'
    },
    {
        image: '/assets/img/pages/contacts/instagram.svg',
        label: 'william.mago',
        action: 'Instagram',
        link: 'https://www.instagram.com/william.mago'
    },
    {
        image: '/assets/img/pages/contacts/github.svg',
        label: 'williammago',
        action: 'GitHub',
        link: 'https://github.com/williammago'
    },
    {
        image: '/assets/img/pages/contacts/linkedin.svg',
        label: 'williammago',
        action: 'LinkedIn',
        link: 'https://www.linkedin.com/in/williammago/'
    },
    {
        image: '/assets/img/pages/contacts/rocketseat.svg',
        label: 'williammago',
        action: 'Rocketseat',
        link: 'https://app.rocketseat.com.br/me/williammago'
    },
    {
        image: '/assets/img/pages/contacts/dev-to.svg',
        label: 'williammago',
        action: 'DEV',
        link: 'https://dev.to/williammago'
    },
    {
        image: '/assets/img/pages/contacts/youtube.png',
        label: 'William Mago',
        action: 'Canal no YouTube',
        link: 'https://youtube.com/channel/UCXJIa44t_QW1dWojbIPxXKg'
    },
    {
        image: '/assets/img/pages/contacts/gmail.svg',
        label: 'euwilliamgoncalves@',
        action: 'gmail.com',
        link: 'mailto:euwilliamgoncalves@gmail.com'
    }
]

export default contactList;